import controller from './received.controller';

export default {
  controller,
  template: require('./received.html')
};



// WEBPACK FOOTER //
// src/app/components/student/received/received.component.ts